import router from '@/router/router';

export default router;
